export const getDropdownFilterBattery = () => {
    return {
        label: "Battery",
        id: "battery",
        i18n: "installationoverview.stateOfCharge",
        options: [
            {
                type: "check",
                variable: "state",
                options: [
                    {
                        id: "charging",
                        i18n: "installationoverview.battery.charging",
                        label: "Charging",
                        variable: "charging",
                        value: false
                    },
                    {
                        id: "discharging",
                        i18n: "installationoverview.battery.discharging",
                        label: "Discharging",
                        variable: "discharging",
                        value: false
                    },
                    {
                        id: "idle",
                        i18n: "installationoverview.battery.idle",
                        label: "Idle",
                        variable: "idle",
                        value: false
                    }
                ]
            },
            {
                type: "minMax",
                label: "SOC",
                variable: "soc",
                min: "",
                max: "",
                measure: "percentage" // used with class ::before
            },
            {
                type: "minMax",
                i18n: "installationoverview.battery.voltage",
                label: "Voltage",
                variable: "voltage",
                min: "",
                max: "",
                measure: "volt" // used with class ::before
            }
        ]
    };
};